import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash,FaHome,FaBuilding,FaCity, FaPlus, FaEye, FaTimes, FaExpand, FaCalendar, FaMapMarker } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import api from "../../services/axiosInstance"

const PortfolioList = () => {
  const [portfolios, setPortfolios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [selectedProject, setSelectedProject] = useState(null);
  const [projects, setProjects] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPortfolios();
  }, []);

  const getProjectIcon = (project) => {
      const title = project.title?.toLowerCase() || '';
      
      if (title.includes('villa') || title.includes('résidence') || title.includes('maison')) {
        return <FaHome className="text-white text-6xl" />;
      } else if (title.includes('commercial') || title.includes('centre') || title.includes('bureau')) {
        return <FaBuilding className="text-white text-6xl" />;
      } else if (title.includes('industriel') || title.includes('usine') || title.includes('entrepôt')) {
        return <FaCity className="text-white text-6xl" />;
      } else {
        return <FaBuilding className="text-white text-6xl" />;
      }
    };

  const getProjectGradient = (project, index) => {
    const gradients = [
      'from-blue-500 to-purple-600',
      'from-green-500 to-teal-600',
      'from-orange-500 to-red-600',
      'from-pink-500 to-rose-600',
      'from-indigo-500 to-blue-600',
      'from-yellow-500 to-orange-600'
    ];
    
    return gradients[index % gradients.length];
  };
   const showProjectDetails = (projectId) => {
  const project = portfolios.find(p => p.id === projectId);
  setSelectedProject(project);
};

  const fetchPortfolios = async () => {
  try {
    const response = await api.get("/portfolio");
    const data = response.data;
    setPortfolios(data);
  } catch (error) {
    setMessage("Erreur: " + (error.response?.data?.message || error.message));
  } finally {
    setLoading(false);
  }
};


  const handleDelete = async (id) => {
  if (!window.confirm("Êtes-vous sûr de vouloir supprimer ce projet ?")) {
    return;
  }

  try {
    await api.delete(`/portfolio/${id}`);

    setMessage("Projet supprimé avec succès !");
    fetchPortfolios(); // Refresh the list
  } catch (error) {
    setMessage(
      "Erreur: " + (error.response?.data?.message || error.message)
    );
  }
};

  const handleEdit = (id) => {
    navigate(`/edit-portfolio/${id}`);
  };

 

  const closeModal = () => {
    setSelectedProject(null);
  };

  const handleAddNew = () => {
    navigate('/add-portfolio');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Chargement des projets...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center mb-8">
          <div>
            <h1 className="text-3xl font-bold text-gray-800">Gestion des Projets</h1>
            <p className="text-gray-600 mt-2">Gérez vos projets portfolio</p>
          </div>
          <button
            onClick={handleAddNew}
            className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            <FaPlus />
            Nouveau Projet
          </button>
        </div>

        {message && (
          <div className={`p-4 rounded-lg mb-6 ${
            message.includes('Erreur') 
              ? 'bg-red-100 text-red-700 border border-red-300' 
              : 'bg-green-100 text-green-700 border border-green-300'
          }`}>
            {message}
          </div>
        )}

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {portfolios.map((portfolio) => (
            <div key={portfolio.id} className="bg-white rounded-xl shadow-lg overflow-hidden">
              {/* Gradient Header */}
              <div className={`h-4 bg-gradient-to-r ${portfolio.gradient || 'from-blue-500 to-purple-600'}`}></div>
              
              <div className="p-6">
                {/* Project Image */}
                {portfolio.images && portfolio.images.length > 0 && (
                  <div className="mb-4">
                    <img
                      src={`${process.env.REACT_APP_API_URL}${portfolio.images[0]}`}
                      alt={portfolio.title}
                      className="w-full h-48 object-cover rounded-lg"
                    />
                  </div>
                )}

                {/* Project Info */}
                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                  {portfolio.title}
                </h3>
                <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                  {portfolio.description}
                </p>

                <div className="space-y-2 text-sm text-gray-600">
                  <div className="flex justify-between">
                    <span>Type:</span>
                    <span className="font-medium capitalize">{portfolio.projectType}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Localisation:</span>
                    <span className="font-medium">{portfolio.location}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Date:</span>
                    <span className="font-medium">{portfolio.date}</span>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex justify-between mt-6 pt-4 border-t border-gray-200">
                  <button
                    onClick={() => showProjectDetails(portfolio.id)}
                    className="flex items-center gap-2 px-3 py-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                  >
                    <FaEye />
                    Voir
                  </button>
                  <button
                    onClick={() => handleEdit(portfolio.id)}
                    className="flex items-center gap-2 px-3 py-2 text-green-600 hover:bg-green-50 rounded-lg transition-colors"
                  >
                    <FaEdit />
                    Modifier
                  </button>
                  <button
                    onClick={() => handleDelete(portfolio.id)}
                    className="flex items-center gap-2 px-3 py-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                  >
                    <FaTrash />
                    Supprimer
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {portfolios.length === 0 && (
          <div className="text-center py-12">
            <div className="text-gray-400 text-6xl mb-4">📁</div>
            <h3 className="text-xl font-semibold text-gray-600 mb-2">Aucun projet</h3>
            <p className="text-gray-500 mb-6">Commencez par ajouter votre premier projet</p>
            <button
              onClick={handleAddNew}
              className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Ajouter un Projet
            </button>
          </div>
        )}
      </div>
      {selectedProject && (
              <div className="fixed inset-0 bg-black bg-opacity-85 backdrop-blur-lg z-50 flex items-center justify-center p-4">
                <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                  <div className={`bg-gradient-to-br ${getProjectGradient(selectedProject, portfolios.findIndex(p => p.id === selectedProject.id))} text-white p-8 relative`}>
                    <button 
                      onClick={closeModal}
                      className="absolute top-4 right-4 bg-white/20 backdrop-blur-sm rounded-full p-2 hover:bg-white/30 transition-colors"
                    >
                      <FaTimes className="text-white text-xl" />
                    </button>
                    
                    <div className="flex items-center space-x-4 mb-4">
                      {getProjectIcon(selectedProject)}
                      <h3 className="text-3xl font-bold">{selectedProject.title}</h3>
                    </div>
                    <p className="text-white/90 text-lg">{selectedProject.description}</p>
                  </div>
                  
                  <div className="p-8">
                    <h4 className="text-2xl font-bold text-gray-800 mb-4">Description du Projet</h4>
                    <p className="text-gray-600 mb-6">{selectedProject.full_description}</p>
                    
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
                      <div className="text-center p-4 bg-gray-50 rounded-lg">
                        <FaCalendar className="text-blue-500 text-xl mx-auto mb-2" />
                        <p className="font-semibold text-gray-800">Date</p>
                        <p className="text-gray-600">{selectedProject.date}</p>
                      </div>
                      <div className="text-center p-4 bg-gray-50 rounded-lg">
                        <FaMapMarker className="text-green-500 text-xl mx-auto mb-2" />
                        <p className="font-semibold text-gray-800">Localisation</p>
                        <p className="text-gray-600">{selectedProject.location}</p>
                      </div>
                      <div className="text-center p-4 bg-gray-50 rounded-lg">
                        <FaExpand className="text-purple-500 text-xl mx-auto mb-2" />
                        <p className="font-semibold text-gray-800">Surface</p>
                        <p className="text-gray-600">{selectedProject.surface}</p>
                      </div>
                      <div className="text-center p-4 bg-gray-50 rounded-lg">
                        <FaCalendar className="text-orange-500 text-xl mx-auto mb-2" />
                        <p className="font-semibold text-gray-800">Durée</p>
                        <p className="text-gray-600">{selectedProject.duration}</p>
                      </div>
                    </div>
                    
                    {/* Display project images if available */}
                    {selectedProject.images && selectedProject.images.length > 0 && (
                      <div className="mb-6">
                        <h4 className="text-2xl font-bold text-gray-800 mb-4">Galerie du Projet</h4>
                        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                          {selectedProject.images.map((image, index) => (
                            <div key={index} className="relative group">
                              <img
                                src={`${process.env.REACT_APP_API_URL}${image}`}
                                alt={`${selectedProject.title} ${index + 1}`}
                                className="w-full h-32 object-cover rounded-lg"
                              />
                              <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-20 transition-opacity duration-300 rounded-lg"></div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    
                    <div className="flex justify-end space-x-4">
                      <button 
                        onClick={closeModal}
                        className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                      >
                        Fermer
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
    </div>
    
  );
};

export default PortfolioList;